<div class="use-case-plan-summary">
  @if (provisionFailure; as failure) {
    <div
      class="use-case-plan-summary__alert use-case-plan-summary__alert--error"
    >
      <span class="use-case-plan-summary__alert-title">
        {{ "use-case-wizard.preview.provisioning-failed" | translate }}
      </span>
      <span>{{ failure.message }}</span>
      @if (failure.failed_ref) {
        <span class="use-case-plan-summary__alert-meta">
          {{ "use-case-wizard.preview.failed-object" | translate }}:
          {{ failure.failed_kind }} / {{ failure.failed_ref }}
        </span>
      }
    </div>
  }

  @if (displayErrors(preview.errors).length > 0) {
    <div
      class="use-case-plan-summary__alert use-case-plan-summary__alert--error"
    >
      <span class="use-case-plan-summary__alert-title">
        {{ "use-case-wizard.preview.plan-has-errors" | translate }}
      </span>
      @for (error of displayErrors(preview.errors); track $index) {
        <span class="use-case-plan-summary__alert-meta">
          @if (error.ref) {
            [{{ error.ref }}]
          }
          @if (error.key) {
            [{{ error.key }}]
          }
          {{ error.message }}
        </span>
      }
    </div>
  }

  @for (warning of preview.warnings; track $index) {
    <div
      class="use-case-plan-summary__alert use-case-plan-summary__alert--warning"
    >
      <span>
        @if (warning.ref) {
          [{{ warning.ref }}]
        }
        {{ warning.message }}</span
      >
    </div>
  }

  <section class="use-case-plan-summary__section">
    <h6 class="use-case-plan-summary__heading">
      {{ "use-case-wizard.preview.objects-to-create" | translate }}
    </h6>

    @if (preview.plan.workspace; as workspace) {
      <div class="use-case-plan-summary__group">
        <span class="use-case-plan-summary__group-label">
          {{ "use-case-wizard.preview.group.workspace" | translate }}
        </span>
        <div class="use-case-plan-summary__item">
          <span class="use-case-plan-summary__item-title">{{
            workspace.title
          }}</span>
          <span class="use-case-plan-summary__item-meta">
            {{
              "use-case-wizard.preview.a-new-workspace-will-be-created"
                | translate
            }}
          </span>
        </div>
      </div>
    }

    @if (preview.plan.feeds.length > 0) {
      <div class="use-case-plan-summary__group">
        <span class="use-case-plan-summary__group-label">
          {{ "use-case-wizard.preview.group.feeds" | translate }}
        </span>
        @for (feed of preview.plan.feeds; track feed.ref) {
          <div class="use-case-plan-summary__item">
            <span class="use-case-plan-summary__item-title">{{
              feed.title
            }}</span>
            @if (feed.human_query) {
              <span class="use-case-plan-summary__item-meta">{{
                feed.human_query
              }}</span>
            }
          </div>
        }
      </div>
    }

    @if (preview.plan.dimensions.length > 0) {
      <div class="use-case-plan-summary__group">
        <span class="use-case-plan-summary__group-label">
          {{ "use-case-wizard.preview.group.dimensions" | translate }}
        </span>
        @for (dimension of preview.plan.dimensions; track dimension.ref) {
          <div class="use-case-plan-summary__item">
            <span class="use-case-plan-summary__item-title">{{
              dimension.title
            }}</span>
            @if (dimension.human_query) {
              <span class="use-case-plan-summary__item-meta">{{
                dimension.human_query
              }}</span>
            }
          </div>
        }
      </div>
    }

    @if (preview.plan.dashboards.length > 0) {
      <div class="use-case-plan-summary__group">
        <span class="use-case-plan-summary__group-label">
          {{ "use-case-wizard.preview.group.dashboards" | translate }}
        </span>
        @for (dashboard of preview.plan.dashboards; track dashboard.ref) {
          <div class="use-case-plan-summary__item">
            <span class="use-case-plan-summary__item-title">{{
              dashboard.title
            }}</span>
            <span class="use-case-plan-summary__item-meta">
              {{
                "use-case-wizard.preview.pages-count"
                  | translate: { count: dashboard.pages.length }
              }}
            </span>
          </div>
        }
      </div>
    }

    @if (preview.plan.alerts.length > 0) {
      <div class="use-case-plan-summary__group">
        <span class="use-case-plan-summary__group-label">
          {{ "use-case-wizard.preview.group.alerts" | translate }}
        </span>
        @for (alert of preview.plan.alerts; track $index) {
          <div class="use-case-plan-summary__item">
            <span class="use-case-plan-summary__item-title">{{
              alert.title
            }}</span>
          </div>
        }
      </div>
    }

    @if (preview.plan.export_schedules.length > 0) {
      <div class="use-case-plan-summary__group">
        <span class="use-case-plan-summary__group-label">
          {{ "use-case-wizard.preview.group.scheduled-reports" | translate }}
        </span>
        @for (schedule of preview.plan.export_schedules; track $index) {
          <div class="use-case-plan-summary__item">
            <span class="use-case-plan-summary__item-title">{{
              schedule.title
            }}</span>
          </div>
        }
      </div>
    }
  </section>

  @if (quotaEntries(preview.quota).length > 0) {
    <section class="use-case-plan-summary__section">
      <h6 class="use-case-plan-summary__heading">
        {{ "use-case-wizard.preview.quota" | translate }}
      </h6>
      <div class="use-case-plan-summary__quota">
        @for (row of quotaEntries(preview.quota); track row.type) {
          <div class="use-case-plan-summary__quota-row">
            <span>{{ row.type }}</span>
            <span>
              {{
                "use-case-wizard.preview.quota-usage"
                  | translate
                    : {
                        requested: row.requested,
                        used: row.used ?? 0,
                        available: row.available ?? 0,
                      }
              }}
            </span>
          </div>
        }
      </div>
    </section>
  }
</div>
